// useZebraPrinter.ts
import { useEffect, useRef, useState } from 'react'

declare global {
  interface Window {
    BrowserPrint: any
  }
}

export function useZebraPrinter() {
  const [devices, setDevices] = useState<any[]>([])
  const [selectedDevice, setSelectedDevice] = useState<any>(null)
  const selectRef = useRef<HTMLSelectElement | null>(null)

  useEffect(() => {
    const setupPrinter = () => {
      if (!window.BrowserPrint) {
        console.warn('BrowserPrint not available')
        return
      }

      // 1. Get default printer
      window.BrowserPrint.getDefaultDevice(
        'printer',
        (device: any) => {
          setSelectedDevice(device)
          const deviceList = [device]

          if (selectRef.current) {
            const option = document.createElement('option')
            option.text = device.name
            selectRef.current.appendChild(option)
          }

          // 2. Discover additional printers
          window.BrowserPrint.getLocalDevices(
            (allDevices: any[]) => {
              const filtered = allDevices.filter(
                (d) => d.uid !== device.uid
              )

              setDevices([device, ...filtered])

              if (selectRef.current) {
                for (const dev of filtered) {
                  const option = document.createElement('option')
                  option.text = dev.name
                  option.value = dev.uid
                  selectRef.current.appendChild(option)
                }
              }
            },
            () => alert('Error getting local devices'),
            'printer'
          )
        },
        (err: any) => {
          console.log('Error: ' + err)
        }
      )
    }

    setupPrinter()
  }, [])

  const sendZpl = (zpl: string) => {
    if (!selectedDevice) {
      alert('No printer selected')
      return
    }
    selectedDevice.send(zpl, undefined, (err: any) =>
      alert('Error: ' + err)
    )
  }

  const onDeviceSelected = (uid: string) => {
    const match = devices.find((d) => d.uid === uid)
    if (match) {
      setSelectedDevice(match)
    }
  }

  return {
    devices,
    sendZpl,
    onDeviceSelected,
    selectedDevice,
    selectRef,
  }
}
